module.exports = __webpack_public_path__ + "static/media/Rubybot-stretch.bd81d778.gif";